export default "__VITE_ASSET__CUm3iwHS__"